import Sortable from "sortablejs";

const SortableHook = {
  mounted() {
    const groupName = this.el.dataset.group;
    const pushEvent = this.el.dataset.pushEvent;
    const sectionId = this.el.dataset.sectionId; // Optional: for block reordering/moving

    // Store sorter instance for cleanup
    this.sorter = new Sortable(this.el, {
      group: groupName, // Allow moving between lists with the same group name
      animation: 150,
      ghostClass: "sortable-ghost", // Class for the drop placeholder
      chosenClass: "sortable-chosen", // Class for the chosen item
      dragClass: "sortable-drag", // Class for the dragging item
      handle: ".drag-handle", // Specify drag handle selector (optional)
      onEnd: (evt) => {
        // evt contains oldIndex, newIndex, from (origin list), to (destination list)
        // item (the dragged element)
        
        // Use cached elements instead of repeated queries
        const params = {
          ids: Array.from(evt.to.children).map(el => el.dataset.id),
          new_index: evt.newIndex
        };

        if (sectionId) {
          params.section_id = sectionId;
        }

        // If moved to a different list (different section for blocks)
        if (evt.from !== evt.to) {
          params.block_id = evt.item.dataset.id;
          params.to_section_id = evt.to.dataset.sectionId;
          this.pushEvent("move_block", params);
        } else {
          // Reordered within the same list
          this.pushEvent(pushEvent, params);
        }
      }
    });
  },

  // Proper cleanup to prevent memory leaks
  destroyed() {
    if (this.sorter) {
      this.sorter.destroy();
      this.sorter = null;
    }
  }
};

export default SortableHook; 